import React, { PropsWithChildren } from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { CheckBox } from '../../../components/CheckBox'
import { textColor, toqueColor } from '../../../theme/colors'
import moment from 'moment'
import { ControlServiceRecord } from '../../../context/Alerts/types'

interface Props extends PropsWithChildren {
  registerKey: string
  name: string
  date: string
  isCheck: boolean
  getItemValue: (values: ControlServiceRecord) => void
  item: ControlServiceRecord
}
export const ItemControlService = ({
  date,
  children,
  name,
  isCheck,
  getItemValue,
  registerKey,
  item,
}: Props) => {
  const momentDate = moment(date)
  const formatDate = momentDate.format('DD-MM-YYYY HH-mm')
  return (
    <TouchableOpacity style={styles.container} onPress={() => getItemValue(item)}>
      <View style={{ flex: 0.4 }}>
        <CheckBox
          isCheck={isCheck}
          item={{ id: registerKey, name: '' }}
          onPress={() => getItemValue(item)}
        />
      </View>

      <View style={{ flex: 1.7 }}>
        <Text style={styles.name}>{name}</Text>
        {children}
      </View>

      <View style={{ flex: 1 }}>
        <Text style={styles.date}>{formatDate}</Text>
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
  },

  name: {
    fontWeight: 'bold',
    fontSize: 16,
    color: textColor,
  },

  date: {
    color: toqueColor,
    fontWeight: 'bold',
    textAlignVertical: 'top',
    flex: 1,
  },
})
